import { render } from "./CIS-Partner-Logo-Wall.vue?vue&type=template&id=7c90ce82&scoped=true"
import script from "./CIS-Partner-Logo-Wall.vue?vue&type=script&lang=js"
export * from "./CIS-Partner-Logo-Wall.vue?vue&type=script&lang=js"

import "./CIS-Partner-Logo-Wall.vue?vue&type=style&index=0&id=7c90ce82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c90ce82"]])

export default __exports__